let e=e=>e?{...e,profile:{...e.profile,email:e.profile.username??e.profile.email??"",firstName:e.profile.name??"",lastName:e.profile.family_name??""}}:null;export{e as normalizeUser};
//# sourceMappingURL=normalize.js.map